var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSensorStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Sensor_Brow_Dis",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #Sensor_Brow_Dis .cls-1 {\n        fill: #3e4346;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18,2A16,16,0,1,1,2,18,16.019,16.019,0,0,1,18,2m0-2A18,18,0,1,0,36,18,18,18,0,0,0,18,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.985,6.42A14.059,14.059,0,0,0,8.041,11.658L9.223,12.84a12.384,12.384,0,0,1,19.637.149l1.181-1.182A14.055,14.055,0,0,0,18.985,6.42",
    transform: "translate(-1 -2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.547,12.285a7.6,7.6,0,0,0-6.32,3.382l1.217,1.217a5.9,5.9,0,0,1,10.3.169l1.223-1.224a7.6,7.6,0,0,0-6.419-3.545",
    transform: "translate(-0.563 -1.387)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.766,9.352a10.826,10.826,0,0,0-8.633,4.309l1.182,1.182a9.165,9.165,0,0,1,15.015.149l1.182-1.182a10.826,10.826,0,0,0-8.745-4.458",
    transform: "translate(-0.781 -1.693)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.994,23.8a4,4,0,1,1-8,0c0-2.234,4-7.953,4-7.953s4,5.719,4,7.953m-2.22-1.317a1.04,1.04,0,1,0,1.028,1.04,1.033,1.033,0,0,0-1.028-1.04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensorStep);
export default __webpack_public_path__ + "static/media/sensor-step.1ab096f84b513c931f4cbbd5733357d4.svg";
export { ForwardRef as ReactComponent };